import { useNavigate } from "react-router-dom";

export default function RectifierAlarmTd(props) {
const navigate = useNavigate();
  const handleClick = () => {
   if (props.link) {
      navigate(props.link);
    }
  };

  return (
    <>
      
      <tr  key={props?.key}   onClick={handleClick}
      className="cursor-pointer hover:bg-light row-radius"
      style={{ cursor: 'pointer', }}>
        <td style={{ width: "80%", maxWidth: "80%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: '13px' }} height={30} className="bg-gray text-dark fw-bold text-start">{props?.title}</td>
        <td style={{ width: "20%", maxWidth: "20%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} className={`${props?.className}`}><span className="badge fs-14">{props?.alarm}</span></td>
      </tr>


    </>
  )
}